import React, { useMemo } from "react";
import { Navigate, useLocation } from "react-router-dom";

const RequireRole = ({ children, allowedRoles = [] }) => {
  const location = useLocation();

  // Get admin info from localStorage
  const adminInfo = useMemo(() => {
    try {
      return JSON.parse(localStorage.getItem("adminInfo") || "{}");
    } catch {
      return {};
    }
  }, []);

  const userRole = adminInfo.role;
  const token = adminInfo.token;

  // Check if user is authenticated
  if (!token) {
    return <Navigate to="/login" state={{ from: location }} replace />;
  }

  // Check if token is expired
  try {
    const expireTime = JSON.parse(localStorage.getItem("expireTime") || "null");
    if (expireTime && new Date().getTime() > new Date(expireTime).getTime()) {
      return <Navigate to="/login" state={{ from: location }} replace />;
    }
  } catch {
    return <Navigate to="/login" state={{ from: location }} replace />;
  }

  // Check if user has required role
  if (!allowedRoles.includes(userRole)) {
    // Redirect to home page if user doesn't have required role
    return <Navigate to="/" replace />;
  }

  return children;
};

export default RequireRole;

